import { render } from "./Bttn.vue?vue&type=template&id=80e9f84c"
import script from "./Bttn.vue?vue&type=script&lang=js"
export * from "./Bttn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__